import React, { Component } from 'react';
import {
  Paper,
  Grid,
  Typography,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
  InputAdornment,
  MenuItem,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableSortLabel,
  TableCell,
  CircularProgress,
  TableFooter,
  TextField,
  Link,
} from '@material-ui/core';

import { capitalize } from "lodash";

import {
  Pagination
} from '@material-ui/lab';

import OpenInNew from '@material-ui/icons/OpenInNew';

import moment from 'moment'
import { CSVLink } from "react-csv"

import SupplierSelect from '../SupplierSelect';
import LocationSelect from '../LocationSelect';
import CostCentreSelect from '../CostCentreSelect';
import DateRangePicker from '../DateRangePicker';
import { getLineItemsReport } from '../../api/resources/LineItems';

import * as defs from '../resourceList.module.scss';

const parseCSVData = lineItems => lineItems.map(li => ({
  "Spend date": li.spendDate.value,
  "Description": li.description,
  "Depot": li.location,
  "Supplier": li.supplier,
  "Status": capitalize(li.status),
  "PO Number": li.poNumber || "(Pending PO)",
  "Contract Number": li.contractNumber,
  "Cost Centre": li.costCentre,
  "Quantity": li.quantity,
  "Cost": li.cost,
  "Total (ex VAT)": li.totalPrice,
  "Raised by": li.user,
  "Approved by": li.approver
}))

const statusesAvailable = [
  'pending',
  'approved',
  'received',
  'closed'
];

const MenuProps = {
  PaperProps: {
    style: {
      position: "absolute",
      top: 0,
      width: 250
    },
  },
  variant: "menu",
  getContentAnchorEl: null
};

const headCells = [
  { id: 'description', numeric: false, sortable: false, label: 'Description' },
  { id: 'purchaseOrder', numeric: false, sortable: false, label: 'Purchase order' },
  { id: 'contractNumber', numeric: false, sortable: false, label: 'Contract number' },
  { id: 'costCentre', numeric: false, sortable: false, label: 'Cost centre' },
  { id: 'quantity', numeric: true, sortable: true, label: 'Quantity' },
  { id: 'cost', numeric: true, sortable: true, label: 'Cost' },
  { id: 'totalPrice', numeric: true, sortable: true, label: 'Total (ex VAT)' },
  { id: 'spendDate', numeric: true, sortable: false, label: 'Spend date' }
];

const columnWidths = {
  description: 'auto',
  purchaseOrder: '15%',
  costCentre: '12%',
  quantity: '9%',
  cost: '9%',
  totalPrice: '12%',
  spendDate: '11%',
};

const PER_PAGE = 20;

class CostExplorer extends Component {

  constructor(props) {
    super();
    this.state = {
      supplier: null,
      lineItems: [],
      statuses: [
        'approved',
        'received',
        'closed'
      ],
      location: null,
      contractNumber: null,
      costCentre: null,
      startDate: moment().subtract(180, 'd').format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      sortField: 'totalPrice',
      sortDirection: 'desc',
      loading: true,
      totalSpent: null,
      csvData: null,
      page: 1,
      totalPages: 1,
    }
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.handleSort = this.handleSort.bind(this)
    this.setDateRange = this.setDateRange.bind(this)
  }

  componentDidMount() {
    this.getLineItems();
  }

  handleUpdate(payload) {
    let [field, value] = Object.entries(payload)[0]
    if (['location', 'costCentre', 'supplier'].includes(field)) {
      value = value || {}
      value = value.name;
    }
    this.setState({
      [field]: value
    }, this.getLineItems)
  }

  setDateRange(range) {
    let { startDate, endDate } = range;
    if (startDate && endDate) {
      startDate = moment(startDate).format("YYYY-MM-DD")
      endDate = moment(endDate).format("YYYY-MM-DD")
    }
    this.setState({ startDate, endDate }, this.getLineItems)
  }

  getLineItems() {
    this.setState({loading: true})
    let { location, supplier, costCentre, contractNumber, startDate, endDate, statuses, sortField, sortDirection } = this.state;
    if (contractNumber === '') contractNumber = null;
    if (contractNumber) contractNumber = `SEL-${contractNumber}`;
    getLineItemsReport({supplier, statuses, location, costCentre, contractNumber, startDate, endDate, sortField, sortDirection}).then(res => {
      const { lineItems, totalSpent } = res;
      const csvData = parseCSVData(lineItems);
      const totalPages = Math.ceil(lineItems.length / PER_PAGE);
      this.setState({ lineItems, totalSpent, csvData, totalPages, loading: false })
    })
  }

  handleSort(id) {
    let { sortField, sortDirection } = this.state;
    if (id != sortField) {
      sortField = id;
      sortDirection = 'desc';
    } else {
      sortDirection = sortDirection === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sortField, sortDirection
    }, this.getLineItems)
  }

  handlePageChange(event, value) {
    this.setState({page: value});
  };
  
  render() {

    const { statuses, contractNumber, startDate, endDate, lineItems, loading, sortField, sortDirection, totalSpent, csvData, page, totalPages} = this.state;


    return (
      <Grid item xs={12} md={12}>
        <Typography style={{marginBottom: '32px'}} variant="h5">
          Cost explorer
        </Typography>
        <Paper style={{padding: '10px 10px', marginBottom: '16px'}}>
          <div style={{display: 'flex'}}>
            <div style={{flex: 1}}>
              <FormControl
                fullWidth
              >
                <InputLabel shrink={true}>Purchase order status</InputLabel>
                <Select
                  onChange={(event) => this.handleUpdate({statuses: event.target.value})}
                  multiple
                  displayEmpty
                  value={statuses}
                  renderValue={(selected) => {
                    if (selected.length === 0) {
                      return <em>Any status</em>;
                    }
                    return selected.map(capitalize).join(", ");
                  }}
                  MenuProps={MenuProps}
                >
                  {statusesAvailable.map((status) => (
                    <MenuItem key={status} value={status}>
                      <Checkbox color="primary" checked={statuses.indexOf(status) > -1} />
                      <ListItemText style={{textTransform: 'capitalize'}} primary={status} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{flex: 1, paddingLeft: '16px'}}>
              <SupplierSelect onUpdate={(value) => this.handleUpdate({supplier: value})} />
            </div>
            <div style={{flex: 1, paddingLeft: '16px'}}>
              <LocationSelect onUpdate={(value) => this.handleUpdate({location: value})} />
            </div>
            <div style={{flex: 1, paddingLeft: '16px'}}>
              <CostCentreSelect onUpdate={(value) => this.handleUpdate({costCentre: value})} />
            </div>
            <div style={{flex: 1, paddingLeft: '16px'}}>
              <TextField
                fullWidth
                onChange={(event) => this.handleUpdate({contractNumber: event.target.value})}
                label="Contract number"
                InputProps={{
                  startAdornment: <InputAdornment position="start">SEL-</InputAdornment>,
                }}
                InputLabelProps={{ shrink: true }}
                placeholder="100123"
                value={contractNumber ? contractNumber : ''} />
            </div>
            <div style={{flex: 1, paddingLeft: '16px'}}>
              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                onChange={(range) => this.setDateRange(range)}
              />
            </div>
          </div>
        </Paper>
        <TableContainer component={Paper} style={{overflowX: 'initial'}}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {headCells.map((headCell) => (
                  <TableCell
                    key={headCell.id}
                    scope={headCell.id === 'description' ? 'row' : ''}
                    align={headCell.numeric ? 'right' : 'left'}
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={sortField === headCell.id ? sortDirection : false}
                    width={columnWidths[headCell.id]}
                  >
                    {headCell.sortable && <TableSortLabel
                      active={sortField === headCell.id}
                      direction={sortField === headCell.id ? sortDirection : 'asc'}
                      onClick={() => this.handleSort(headCell.id)}
                    >
                      <strong>{headCell.label}</strong>
                      {sortField === headCell.id && headCell.sortable ? (
                        <span style={{visibility: 'hidden', display: 'none'}}>
                          {sortDirection === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                    </TableSortLabel>}
                     { !headCell.sortable && <strong>{headCell.label}</strong> }
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              { loading && <tr><td colSpan='7' style={{height: '200px', textAlign: 'center'}}><CircularProgress /></td></tr>}
              { !loading && lineItems.length === 0 && <tr><td  colSpan='7' className={defs.resourceListFailedMessage}>No matching line items found</td></tr> }
              { !loading && lineItems.length > 0 && lineItems.slice((page - 1) * PER_PAGE, (page - 1) * PER_PAGE + PER_PAGE).map((lineItem, idx) => (
                <TableRow key={idx}>
                  <TableCell scope="row" width={columnWidths.description}>{lineItem.description}</TableCell>
                  <TableCell align="left" width={columnWidths.purchaseOrder}>
                    <Link target="_blank" href={`/purchase-orders/${lineItem.purchaseOrderRef.value.id}`}>
                      {lineItem.poNumber ? lineItem.poNumber : "(Pending PO)"}
                      <OpenInNew style={{display: 'inline-block', fontSize: '14px', marginTop: '3px', marginLeft: '5px', verticalAlign: 'top'}} />
                    </Link>
                  </TableCell>
                  <TableCell scope="row" width={columnWidths.contractNumber}>{lineItem.contractNumber || "-"}</TableCell>
                  <TableCell align="left" style={{overflow: 'hidden', 'whiteSpace': 'nowrap'}} width={columnWidths.costCentre}>{lineItem.costCentre}</TableCell>
                  <TableCell align="right" width={columnWidths.quantity}>{lineItem.quantity}</TableCell>
                  <TableCell align="right" width={columnWidths.cost}>£{lineItem.cost.toFixed(2)}</TableCell>
                  <TableCell align="right" width={columnWidths.totalPrice}>£{lineItem.totalPrice.toFixed(2)}</TableCell>
                  <TableCell align="right" width={columnWidths.spendDate}>{lineItem.spendDate.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
            { !loading && lineItems.length > 0 && <TableFooter style={{position: 'sticky', bottom: '0', backgroundColor: '#fff'}}>
              <TableRow>
                <TableCell colSpan='6' align="right" style={{fontSize: '18px', color: '#111'}}>Total (ex VAT):</TableCell>
                <TableCell colSpan='1' align="right"><strong style={{fontSize: '18px', color: '#111'}}>£{totalSpent.toFixed(2)}</strong></TableCell>
                <TableCell colSpan='1' align="right">
                  <CSVLink data={csvData} filename="sel-spending-report.csv">Download CSV</CSVLink>
                </TableCell>
              </TableRow>
            </TableFooter>}
          </Table>
        </TableContainer>

        <Pagination style={{marginTop: '26px'}} count={totalPages} page={page} onChange={this.handlePageChange} />

      </Grid>
    );
  }
}
export default CostExplorer
;